export default __webpack_public_path__ + "static/media/ISWEC-14.832ce280.pdf";